/**
 * Event audience helpers for Event Calendar registration flows.
 * Youth Only → parent registers linked children (parent is guardian, not attendee).
 * All Ages → parent can register linked children and/or themselves.
 * Adult Only → self registration only (no linked-children picker).
 */

export function getEventAudienceType(ev) {
  return (ev?.audience_type != null ? String(ev.audience_type) : "").trim();
}

export function isYouthOnlyEvent(ev) {
  return getEventAudienceType(ev) === "Youth Only";
}

export function isAllAgesEvent(ev) {
  return getEventAudienceType(ev) === "All Ages";
}

export function isAdultOnlyEvent(ev) {
  return getEventAudienceType(ev) === "Adult Only";
}

/** Logged-in Parent uses multi-attendee (linked children) registration for these audiences. */
export function eventUsesParentMultiAttendeeFlow(ev) {
  return isYouthOnlyEvent(ev) || isAllAgesEvent(ev);
}

/** Parent may also be selected as an event participant (All Ages only). */
export function parentIsRegistrableAttendeeForEvent(ev) {
  return isAllAgesEvent(ev);
}

export function userInfoHasParentRole(info) {
  const roles = info?.roles;
  if (!Array.isArray(roles)) return false;
  return roles.some((r) => String(r).trim() === "Parent");
}

/**
 * @param {object|null|undefined} userInfo
 * @param {object|object[]} events
 */
export function shouldOpenParentRegistrationFlow(userInfo, events) {
  if (!userInfoHasParentRole(userInfo)) return false;
  const list = Array.isArray(events) ? events : events ? [events] : [];
  return list.some(eventUsesParentMultiAttendeeFlow);
}

/** True when any selected event should include the parent as a selectable attendee row. */
export function shouldIncludeParentSelfAttendee(events) {
  const list = Array.isArray(events) ? events : events ? [events] : [];
  return list.some(parentIsRegistrableAttendeeForEvent);
}
